import {Component, Inject, OnInit} from '@angular/core';
import {
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
  MatDialogRef as MatDialogRef
} from '@angular/material/dialog';

@Component({
    selector: 'app-alert-dialog',
    templateUrl: './alert-dialog.component.html',
    styleUrls: ['./alert-dialog.component.scss'],
    standalone: false
})
export class AlertDialogComponent implements OnInit {

  public title: string;
  public message: string;
  public okLabel: string;

  constructor(
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.title = data.title;
    this.message = data.message;
    this.okLabel = data.okLabel || 'Ok';
  }

  ngOnInit(): void {
  }

  onDismiss(): void {
    this.dialogRef.close();
  }
}
